import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../services/helpers.service';
import { UserService } from '../../../services/user.service';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-tfacode',
  templateUrl: './tfacode.component.html',
  styleUrls: ['./tfacode.component.scss'],
  providers: [MessageService],
})
export class TFACodeComponent implements OnInit {
  tfaForm: FormGroup = new FormGroup({
    code: new FormControl('', [
      Validators.required,
      (control) => {
        const value = control.value as string;
        if (value && value.length !== 6) {
          return { exactLength: true };
        }
        return null;
      },
    ]),
  });

  isBusy: boolean = false;
  showError: boolean = false;
  errorMessage: string = '';

  returnURL: string = null;

  constructor(
    private route: ActivatedRoute,
    public authService: AuthenticationService,
    public messageService: MessageService,
    public router: Router,
    public userService: UserService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
  ) {
    // // Access the values from the service
    // console.log(this.authService.username);
    // console.log(this.authService.password);

    this.route.queryParams.subscribe((params) => {
      if (params['returnUrl']) {
        this.returnURL = params['returnUrl'];
      }
    });
  }

  ngOnInit() {
    if (
      this.authService.username == null ||
      this.authService.username == undefined
    ) {
      this.router.navigateByUrl('');
      return;
    }
  }

  validateControl(controlName: string) {
    return (
      this.tfaForm.get(controlName).invalid &&
      this.tfaForm.get(controlName).touched
    );
  }

  hasError(controlName: string, errorName: string) {
    return this.tfaForm.get(controlName).hasError(errorName);
  }

  signInWithCode(tfaFormValue: any) {
    console.log(tfaFormValue);
    this.showError = false;
    this.errorMessage = '';
    this.isBusy = true;

    this.authService
      .tokenLogin(
        this.authService.username,
        this.authService.password,
        tfaFormValue.code,
      )
      .subscribe(
        (result) => {
          console.log('success');
          console.log(result);
          if (result.valid == false) {
            //Invalid code value received
            this.showError = true;
            this.errorMessage = 'Invalid code, try again.';
            this.isBusy = false;
            return;
          }

          //Clear sensitive values from auth service
          let userName = this.authService.username;
          let password = this.authService.password;

          this.authService.username = null;
          this.authService.password = null;

          //Is valid, sign user in - duplicate of login code here ---->
          this.helpersService.saveAuthData(result);
          this.helpersService.saveAuthDataNew(result);

          this.userService.getUserDetail(userName).subscribe(
            (user) => {
              const profile = user;
              const roles = profile.UserRoles.filter((x) => {
                return x.PartnerID > 0;
              });
              var shops = roles
                .map((x) => {
                  return x.PartnerID;
                })
                .filter((value, index, self) => {
                  return self.indexOf(value) === index;
                });

              if (shops.length > 0) {
                var defaultPartnerID = shops[0];
                profile.PartnerID = defaultPartnerID;

                var shopRoles = roles
                  .filter((x) => {
                    return x.PartnerID === defaultPartnerID;
                  })
                  .map((x) => {
                    return x.RoleID;
                  });

                profile.isAdmin =
                  shopRoles.includes(2) || profile.UserRoles.includes(3);
                profile.isManager = shopRoles.includes(3);
                profile.isTechnician =
                  (shopRoles.includes(1) || shopRoles.includes(4)) &&
                  !profile.isAdmin &&
                  !profile.isManager;
              }
              this.helpersService.saveProfileData(profile);

              this.userService.getUserRolesInsurance(profile.ID).subscribe(
                (permissions) => {
                  this.helpersService.saveProfileInsuranceRoles(permissions);
                },
                (error) => {
                  this.isBusy = false;
                  this.showError = true;
                  this.errorMessage = 'Failed to get account permissions.';
                },
              );

              if (this.returnURL) {
                this.router.navigateByUrl(this.returnURL);
              } else if (profile.IsSuperUser) {
                this.router.navigateByUrl('/administration/stores');
              } else if (profile.isAdmin || profile.isManager) {
                this.router.navigateByUrl('/store/product-redirect-loader');
              } else if (profile.isTechnician) {
                this.router.navigateByUrl('/store/product-redirect-loader');
              } else {
                //if (isDevMode()) {
                this.router.navigateByUrl('/clubs');
              }
            },
            (error) => {
              this.isBusy = false;
              this.showError = true;
              this.errorMessage =
                'There was an error getting the user profile details. Please try again later.';
            },
          );
        },
        (error) => {
          console.log('error');
          console.error(error);
          this.showError = true;
          this.errorMessage = 'Failed to validate code.';

          this.isBusy = false;
        },
      );
  }

  // register2FA(){
  //   this.authService.allowSkip = false;
  //   this.router.navigateByUrl('/2fasetup');
  // }

  home() {
    this.router.navigateByUrl('/');
  }
}
